import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import debounce from 'lodash.debounce'
import Modal from 'components/modal'

import 'less/credit-incentive-modal.less'

const BulkIncentive = props => {
  const [modelIsOpen, setModelOpen] = useState(false)

  const creditIncentive = () => {
    const payload = {
      timeSlotIds: props.selectedTimeSlotIds,
    }
    props.creditIncentive(payload)
  }

  useEffect(() => {
    if(!props.selectedTimeSlotIds.length) setModelOpen(false)
  }, [props.selectedTimeSlotIds])
  
  const debouncedSearch = debounce(props.fetchInterviewsList, 1000)

  useEffect(() => {
    if (props.isCreditingSuccessful) {
      debouncedSearch()
    }
  }, [props.isCreditingSuccessful])

  return (
    <div className='bulk-incentive-container'>
      <button className={`bulk-incentive ${props.bulkIncentiveModeEnabled ? '' : 'default'} btn btn-primary`} disabled={props.bulkIncentiveModeEnabled} onClick={() => props.enableBulkIncentiveMode()}>
        <i className='im-ss-flash'></i>
        {props.t('incentive.bulk.btn.text')}
      </button>
      {props.bulkIncentiveModeEnabled && (
        <>
          <div className='bulk-incentive-mode-container'>
            <span><i className='im-ss-flash'></i>{`${props.t('incentive.bulk.mode')}`}</span>
            <span className="bulk-incetive-cancel" onClick={() => props.disableBulkIncentiveMode()}>
              <i className='im-ss-delete'></i>{props.t('incentive.bulk.cancel')} 
            </span>
            <Modal
              isOpen={modelIsOpen}
              className="credit-incentive-modal"
              submitBtnText={props.t('incentive.credit.confirm')}
              onCancel={() => setModelOpen(false)}
              enableSubmit={!props.isSubmitting}
              onSubmit={creditIncentive}
              isSubmitting={props.isSubmitting}
              type='confirm-dialog'
            >
              <div className="react-dialog-confirm-msg">
                <p> {`${props.t('incentive.bulk.modal.message')}`}</p>
              </div>
            </Modal>
          </div> 
          <button className={`bulk-incentive default ${!props.selectedTimeSlotIds.length ? 'dimmed' : ''} confirm-selection btn btn-primary`} disabled={!props.selectedTimeSlotIds.length} onClick={() => setModelOpen(true)}>
            {props.t('incentive.bulk.confirm.selection')}
          </button>
          <div className="select-all-checkbox">
            <span>Select All</span>
            <input 
              type="checkbox"
              onChange={props.handleSelectAll}
              checked={props.isSelectAllChecked}
            />
          </div>
        </>
      )}
    </div>
    
  )
}

const mapStateToProps = state => ({
  isSubmitting: state.creditIncentiveReducer.isCrediting,
  isCreditingSuccessful: state.creditIncentiveReducer.isCreditingSuccessful,
  selectedTimeSlotIds: state.creditIncentiveReducer.selectedTimeSlotIds,
  bulkIncentiveModeEnabled: state.creditIncentiveReducer.bulkIncentiveModeEnabled,
})

const mapDispatchToProps = {
  creditIncentive: (payload) => ({ 
    type: 'CREDIT_INCENTIVE_REQUESTED', 
    payload 
  }),
  resetUpdateState: () => ({
    type: 'RESET_CREDIT_INCENTIVE_STATE'
  }),
  fetchInterviewsList: (payload) => ({
    type: 'FETCH_INTERVIEWS_LIST_REQUESTED',
    payload
  }),
  enableBulkIncentiveMode: () => ({
    type: 'BULK_INCENTIVE_MODE_ENABLED'
  }),
  disableBulkIncentiveMode: () => ({
    type: 'BULK_INCENTIVE_MODE_DISABLED'
  })
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkIncentive)